import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduateResults2022 from 'src/components/PostGraduationContent/Residence2022/Results/PostGraduateResults2022'

const Results2022 = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <PostGraduateResults2022 />
      <Footer />
    </>
  )
}

export default Results2022
